"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.knowledge.updated': 'Base di conoscenza avatar aggiornata con successo',
    'avatar.knowledge.load.error': 'Errore nel caricamento della conoscenza avatar',
    'avatar.knowledge.update.error': 'Errore nell\'aggiornamento della conoscenza avatar',
};
